import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/alternateCreate';
import Table from '../../Tables/DataTable/components/DataTable';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const alternateCreate = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">ALTERNATE PRODUCT MASTER - Upload</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

alternateCreate.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(alternateCreate);
